import React from 'react';
import AsignarCursosTurnoCatalog from './AsignarCursosTurnoCatalog';

export default function AsignarCursosTurnoPage() {
    return (
        <div className="lms-page-container">
            <AsignarCursosTurnoCatalog />
        </div>
    );
}
